<script lang="ts">
import { defineComponent } from 'vue'
import { AlluvialChart, type AlluvialChartOptions, type ChartTabularData } from '@carbon/charts'
import CcvBaseChart from './CcvBaseChart.vue'

interface Props {
	data: ChartTabularData
	options: AlluvialChartOptions
}

export default defineComponent({
	name: 'CcvAlluvialChart',
	extends: CcvBaseChart,
	props: {
		data: {
			type: Object as () => ChartTabularData,
			required: true
		},
		options: {
			type: Object as () => AlluvialChartOptions,
			required: true
		}
	},
	mounted() {
		const { data, options } = this.$props as Props
		this.coreChart = new AlluvialChart(this.$el as HTMLDivElement, {
			data,
			options
		})
	}
})
</script>

<template>
	<div class="ccv-alluvial-chart"></div>
</template>
